import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex h-screen bg-gray-50 overflow-hidden" }
const _hoisted_2 = { class: "flex flex-col flex-1 min-w-0 px-4" }
const _hoisted_3 = { class: "flex-1 overflow-auto py-4 mt-6 border-t border-gray-100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SideBar = _resolveComponent("SideBar")!
  const _component_NavBar = _resolveComponent("NavBar")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_SideBar, {
      isOpen: _ctx.sidebarOpen,
      onClose: _ctx.closeSidebar
    }, null, 8, ["isOpen", "onClose"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_NavBar, { onToggleSidebar: _ctx.toggleSidebar }, null, 8, ["onToggleSidebar"]),
      _createElementVNode("main", _hoisted_3, [
        _createVNode(_component_router_view)
      ])
    ])
  ]))
}